<template>
	<div class="user-center-container invoice-title-page">
		<div class="user-center-content">
			<div class="breadcrumb-row">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/user/invoiceManagement/myInvoice' }">我的发票</el-breadcrumb-item>
					<el-breadcrumb-item>发票抬头管理</el-breadcrumb-item>
				</el-breadcrumb>
				<el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增发票抬头</el-button>
			</div>

			<div class="statistics-grid">
				<div class="statistics-card total-card">
					<div class="statistics-icon"><i class="el-icon-tickets"></i></div>
					<div class="statistics-content">
						<div class="statistics-label">抬头总数</div>
						<div class="statistics-value">{{ statistics.total }}</div>
					</div>
				</div>
				<div class="statistics-card personal-card">
					<div class="statistics-icon"><i class="el-icon-user"></i></div>
					<div class="statistics-content">
						<div class="statistics-label">个人抬头</div>
						<div class="statistics-value">{{ statistics.personal }}</div>
					</div>
				</div>
				<div class="statistics-card company-card">
					<div class="statistics-icon"><i class="el-icon-office-building"></i></div>
					<div class="statistics-content">
						<div class="statistics-label">企业抬头</div>
						<div class="statistics-value">{{ statistics.company }}</div>
					</div>
				</div>
			</div>

			<div class="title-list-section">
				<div class="section-header">
					<div class="section-title">发票抬头列表</div>
					<div class="section-description">共 {{ statistics.total }} 条抬头信息</div>
				</div>

				<div v-loading="loading" class="title-list">
					<template v-if="invoiceTitleList.length">
						<div
							v-for="(item, index) in invoiceTitleList"
							:key="item.id || index"
							:class="['title-card', { 'is-default': item.isDefault }]"
						>
							<div class="title-main">
								<div class="title-tags">
									<el-tag :type="isPersonal(item) ? 'success' : ''" size="small">
										{{ isPersonal(item) ? '个人' : '企业单位' }}
									</el-tag>
									<el-tag v-if="item.isDefault" type="warning" size="small">默认</el-tag>
								</div>
								<div class="title-name">{{ item.taxpayer }}</div>
								<div v-if="!isPersonal(item)" class="tax-number">
									<span class="field-label">税号</span>
									<span>{{ item.taxpayerCode || '--' }}</span>
								</div>
							</div>
							<div class="title-actions">
								<el-button v-if="!item.isDefault" size="small" type="primary" plain @click="handleSetDefault(item)">
									设为默认
								</el-button>
								<el-button size="small" type="primary" plain icon="el-icon-edit-outline" @click="handleEdit(item)">
									编辑
								</el-button>
								<el-button size="small" icon="el-icon-document-copy" @click="handleCopy(item)">复制</el-button>
								<el-button size="small" type="danger" plain icon="el-icon-delete" @click="handleDelete(item)">
									删除
								</el-button>
							</div>
						</div>
					</template>
					<empty-content v-else empty-text="暂无发票抬头，请新增抬头信息"></empty-content>
				</div>
			</div>
		</div>

		<jr-dialog
			:title="dialogTitle"
			:visible.sync="dialogVisible"
			:show-btn="false"
			width="700px"
			custom-class="invoice-title-dialog"
			@closed="handleDialogClosed"
		>
			<template slot="content">
				<el-form ref="invoiceTitleForm" :model="invoiceTitleForm" :rules="rules" label-width="140px">
					<el-form-item label="开票类型：" prop="invoiceType">
						<el-radio-group v-model="invoiceTitleForm.invoiceType">
							<el-radio label="0">增值税普通发票</el-radio>
							<el-radio label="1">增值税专用发票</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="抬头类型：" prop="headType">
						<el-radio-group v-model="invoiceTitleForm.headType">
							<el-radio label="0">企业</el-radio>
							<el-radio label="1">个人</el-radio>
						</el-radio-group>
					</el-form-item>
					<template v-if="invoiceTitleForm.headType === '0'">
						<el-form-item label="企业名称：" prop="taxpayer">
							<el-input v-model.trim="invoiceTitleForm.taxpayer" placeholder="请输入企业名称"></el-input>
						</el-form-item>
						<el-form-item label="纳税人识别号：" prop="taxpayerCode">
							<el-input v-model.trim="invoiceTitleForm.taxpayerCode" placeholder="请输入纳税人识别号"></el-input>
						</el-form-item>
						<el-form-item label="企业注册地址：" prop="companyAddr">
							<el-input v-model.trim="invoiceTitleForm.companyAddr" placeholder="请输入企业注册地址"></el-input>
						</el-form-item>
						<el-form-item label="企业注册电话：" prop="companyPhone">
							<el-input v-model.trim="invoiceTitleForm.companyPhone" placeholder="请输入企业注册电话"></el-input>
						</el-form-item>
						<el-form-item label="开户银行：" prop="bankName">
							<el-input v-model.trim="invoiceTitleForm.bankName" placeholder="请输入开户银行"></el-input>
						</el-form-item>
						<el-form-item label="银行账号：" prop="bankCode">
							<el-input v-model.trim="invoiceTitleForm.bankCode" placeholder="请输入银行账号"></el-input>
						</el-form-item>
					</template>
					<template v-else-if="invoiceTitleForm.headType === '1'">
						<el-form-item label="发票抬头：" prop="taxpayer">
							<el-input v-model.trim="invoiceTitleForm.taxpayer" placeholder="请输入个人或姓名"></el-input>
						</el-form-item>
					</template>
					<el-form-item label="设为默认：">
						<el-switch v-model="invoiceTitleForm.isDefault"></el-switch>
					</el-form-item>
					<div class="form-tips">
						提示：请按照电子商务法及发票管理办法等相关规定填写发票信息，若因填写无效信息或非法信息等造成包括但不限于无法成功开具发票等后果或法律责任，由您自行承担。
					</div>
				</el-form>
				<div class="form-button-group">
					<el-button @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" :loading="submitLoading" @click="handleSubmit">保存</el-button>
				</div>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import { deleteInvoiceTitle, queryInvoiceTitleList, saveInvoiceTitle, setDefaultInvoiceTitle } from '@/api/invoice'

	const createEmptyTitleForm = () => ({
		id: undefined,
		invoiceType: '0',
		headType: '0',
		taxpayer: '',
		taxpayerCode: '',
		companyAddr: '',
		companyPhone: '',
		bankName: '',
		bankCode: '',
		isDefault: false
	})

	export default {
		name: 'InvoiceTitleManagement',
		components: {
			JrDialog
		},
		data() {
			return {
				loading: false,
				submitLoading: false,
				invoiceTitleList: [],
				dialogVisible: false,
				dialogMode: 'add',
				invoiceTitleForm: createEmptyTitleForm(),
				rules: {
					invoiceType: [{ required: true, message: '请选择开票类型', trigger: 'change' }],
					headType: [{ required: true, message: '请选择抬头类型', trigger: 'change' }],
					taxpayer: [{ required: true, message: '请输入纳税人名称', trigger: 'blur' }],
					taxpayerCode: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }],
					companyAddr: [{ required: false, message: '请输入企业注册地址', trigger: 'blur' }],
					companyPhone: [{ required: false, message: '请输入企业注册电话', trigger: 'blur' }],
					bankName: [{ required: false, message: '请输入开户银行', trigger: 'blur' }],
					bankCode: [{ required: false, message: '请输入银行账号', trigger: 'blur' }]
				}
			}
		},
		computed: {
			statistics() {
				const personal = this.invoiceTitleList.filter(item => this.isPersonal(item)).length
				return {
					total: this.invoiceTitleList.length,
					personal,
					company: this.invoiceTitleList.length - personal
				}
			},
			dialogTitle() {
				return {
					add: '新增发票抬头',
					edit: '编辑发票抬头',
					copy: '复制发票抬头'
				}[this.dialogMode]
			}
		},
		created() {
			this.queryList()
		},
		methods: {
			async queryList() {
				this.loading = true
				try {
					const { data } = await queryInvoiceTitleList()
					this.invoiceTitleList = Array.isArray(data) ? data : []
				} finally {
					this.loading = false
				}
			},
			isPersonal(item) {
				return String(item.headType) === '1'
			},
			handleAdd() {
				this.dialogMode = 'add'
				this.invoiceTitleForm = createEmptyTitleForm()
				this.dialogVisible = true
			},
			handleEdit(item) {
				this.dialogMode = 'edit'
				this.invoiceTitleForm = { ...createEmptyTitleForm(), ...item }
				this.dialogVisible = true
			},
			handleCopy(item) {
				this.dialogMode = 'copy'
				this.invoiceTitleForm = { ...createEmptyTitleForm(), ...item, id: undefined, isDefault: false }
				this.dialogVisible = true
			},
			async handleSetDefault(item) {
				await setDefaultInvoiceTitle({ id: item.id })
				this.$message.success('已设为默认抬头')
				this.queryList()
			},
			handleDelete(item) {
				this.$modal
					.confirm('删除后无法恢复，确认删除该发票抬头吗？')
					.then(async () => {
						await deleteInvoiceTitle({ id: item.id })
						this.$message.success('删除成功')
						this.queryList()
					})
					.catch(() => {})
			},
			handleSubmit() {
				this.$refs.invoiceTitleForm.validate(valid => {
					if (!valid) return

					this.submitLoading = true
					saveInvoiceTitle({ ...this.invoiceTitleForm })
						.then(() => {
							this.$message.success('保存成功')
							this.dialogVisible = false
							this.queryList()
						})
						.finally(() => {
							this.submitLoading = false
						})
				})
			},
			handleDialogClosed() {
				this.$refs.invoiceTitleForm && this.$refs.invoiceTitleForm.clearValidate()
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';
	@import '~@/styles/element-reset.scss';

	.breadcrumb-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-bottom: 18px;
		border-bottom: 1px solid #e7e9ed;

		::v-deep .el-breadcrumb__inner.is-link {
			color: #2671cb;
			font-weight: normal;
		}
	}

	.statistics-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 20px;
		margin: 22px 0;
	}

	.statistics-card {
		display: flex;
		align-items: center;
		min-height: 112px;
		padding: 20px 24px;
		border: 1px solid #e6ebf2;
		border-radius: 8px;
		background: #ffffff;
		box-shadow: 0 4px 14px rgba(27, 69, 119, 0.06);

		.statistics-icon {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 58px;
			height: 58px;
			margin-right: 18px;
			border-radius: 12px;
			font-size: 28px;
		}

		.statistics-label {
			margin-bottom: 6px;
			color: #7b8493;
		}

		.statistics-value {
			font-size: 30px;
			font-weight: bold;
			color: #27364b;
		}

		&.total-card .statistics-icon {
			color: #2671cb;
			background: #edf5ff;
		}

		&.personal-card .statistics-icon {
			color: #20a06b;
			background: #eaf8f2;
		}

		&.company-card .statistics-icon {
			color: #d88b22;
			background: #fff5e7;
		}
	}

	.title-list-section {
		border: 1px solid #e6ebf2;
		background: #ffffff;
	}

	.section-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 18px 20px;
		border-bottom: 1px solid #e6ebf2;

		.section-title {
			font-size: 17px;
			font-weight: bold;
			color: #333333;
		}

		.section-description {
			color: #909399;
		}
	}

	.title-list {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		align-items: stretch;
		gap: 18px;
		min-height: 260px;
		padding: 20px;

		::v-deep .empty-wrapper {
			grid-column: 1 / -1;
		}
	}

	.form-tips {
		padding: 12px 16px;
		color: #999999;
		font-size: 13px;
		line-height: 22px;
		background: #fafafa;
	}

	.title-card {
		display: flex;
		flex-direction: column;
		min-width: 0;
		min-height: 190px;
		padding: 20px;
		border: 1px solid #dfe5ec;
		border-radius: 8px;
		background: #ffffff;
		box-sizing: border-box;
		transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;

		&:hover {
			border-color: #9ec5f2;
			box-shadow: 0 8px 22px rgba(38, 113, 203, 0.12);
			transform: translateY(-3px);
		}

		&.is-default {
			border: 2px solid #2671cb;
			padding: 19px;
			box-shadow: 0 5px 16px rgba(38, 113, 203, 0.1);

			&:hover {
				box-shadow: 0 10px 24px rgba(38, 113, 203, 0.18);
			}
		}

		.title-main {
			width: 100%;
			min-width: 0;
		}

		.title-tags {
			margin-bottom: 9px;

			.el-tag + .el-tag {
				margin-left: 8px;
			}
		}

		.title-name {
			margin-bottom: 8px;
			font-size: 17px;
			font-weight: 500;
			color: #303846;
			line-height: 25px;
			word-break: break-all;
		}

		.tax-number {
			display: flex;
			min-width: 0;
			color: #697386;
			line-height: 22px;
			word-break: break-all;

			.field-label {
				flex-shrink: 0;
				margin-right: 12px;
				color: #9aa1ad;
			}
		}

		.title-actions {
			display: flex;
			flex-wrap: wrap;
			gap: 8px;
			width: 100%;
			margin-top: auto;
			padding-top: 16px;
			border-top: 1px solid #edf0f4;

			.el-button + .el-button {
				margin-left: 0;
			}
		}
	}

	.form-button-group {
		display: flex;
		justify-content: center;
		gap: 12px;
		padding: 22px 0 10px;

		.el-button + .el-button {
			margin-left: 0;
		}
	}

	@media (max-width: 1100px) {
		.title-list {
			grid-template-columns: 1fr;
		}
	}
</style>
